
namespace app.tarefas.minhasTarefas {
    "use strict";

    import IPromise = ng.IPromise;
    import IQService = ng.IQService;
    import CamposExportacaoTarefa = app.tarefas.minhasTarefas.CamposExportacaoTarefa;

    declare let angular: ng.IAngularStatic;
    declare var XLSX;

    export class ExportarTarefasService {

        private sheet_name: string = "Histórico de tarefas";
        private header: Array<string> = [
            "Nome da tarefa",
            "Data de criação",
            'Data de atribuição',
            'Usuário responsável',
            'Situação final',
            'Data de conclusão/cancelamento',
            'Resultado da conclusão/Justificativa do cancelamento',
            'Informações extras',
            'Rótulos'
        ];
		
		private usersNames: Map = new Map();

        /** @ngInject **/
        constructor(private $q: IQService, private $filter: ng.IFilterService) { }

        public exportarHistoricoTarefas(tasks: ITask[],
			usersNames: Map,
            parametros: CamposExportacaoTarefa[], nomeRelatorio: string): IPromise<void> {

			this.usersNames = usersNames;
            let defer: ng.IDeferred<void> = this.$q.defer();

            var conteudo = this.formatarConteudoRelatorio(tasks, parametros);

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.json_to_sheet([]);

            var cabecalho = this.header.filter(h => parametros.filter(p => p.descricao === h).length > 0);
            var wscols = [];

            // definindo o tamanho das colunas de acordo com o tamanho do titulo
            cabecalho.forEach((c) => {
                if (c.length > 25)
                    wscols.push({ wch: c.length })
                else
                    wscols.push({ wch: 25 })
            });

            ws["!cols"] = wscols;

            XLSX.utils.sheet_add_aoa(ws, [cabecalho]);
            XLSX.utils.sheet_add_json(ws, conteudo, { origin: 'A2', skipHeader: true });
            XLSX.utils.book_append_sheet(wb, ws, this.sheet_name);
            XLSX.writeFile(wb, nomeRelatorio, (err: any) => {
                (err) ? defer.reject(err) : defer.resolve();
            });
            defer.resolve();
            return defer.promise;
        }

        private formatarConteudoRelatorio(tasks: ITask[], parametros: CamposExportacaoTarefa[]) {
            let conteudo = [];
            tasks.forEach(tarefa => {
                let taskValues = {}, result = [];
                // Formata os campos de acordo com regras de cada um
                parametros.forEach((param) => {
                    let descricao = param["descricao"];
                    if (!!param.nome) {
                        taskValues[descricao] = this.aplicarRegras(tarefa, param.nome, param);
                    } else if (!!param.funcaoDeFormatacao) {
                        let text = this[param.funcaoDeFormatacao](tarefa);
                        taskValues[descricao] = text;
                    }
                });
                // Ordena o conteúdo
                this.header.forEach((header) => {
                    if (!!taskValues[header])
                        result.push(taskValues[header]);

                });
                conteudo.push(result);
            });
            return conteudo;
        }

        private aplicarRegras(tarefa, fieldName: string, param: CamposExportacaoTarefa) {
            if (param.tipo === 'array' && !!tarefa[fieldName]) {
                if (fieldName === 'extraInfo') {
                    return this.formatarExtraInfo(tarefa[fieldName]);
                } else if (!!tarefa[fieldName][0] && !!tarefa[fieldName][0]['name']) {
                    return tarefa[fieldName].map(t => t.name).join(', ');
                }
            } else if (param.tipo === 'date') {
                return this.formatDate(tarefa[fieldName]);
            } else if (!tarefa[fieldName] || tarefa[fieldName] == '') {
                return '-';
            } else if (fieldName === 'assignee') {
				return this.formatNomeUsuario(tarefa[fieldName]);
			}
            return tarefa[fieldName];
        }

        private formatDate(date: number | string): string {
            if (!!date)
                return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
            return '-';
        }

        private formatarExtraInfo(extraInfo: Array<any>) {
            let text = '';
            for (const chave in extraInfo) {
                if (!!extraInfo[chave]) {
                    text += `${chave}: ${extraInfo[chave]}; `;
                }
            }

            if (text == '') text = '-';

            return text.trim();
        }

        public formatDataConclusaoCancelamento(tarefa: ITask) {
            if (tarefa.completed) {
                return this.formatDate(tarefa.completedDate);
            } else if (!!tarefa.cancellation && !!tarefa.cancellation.canceledDate) {
                return this.formatDate(tarefa.cancellation.canceledDate);
            }
            return '-';
        }

        public formatResultadoJustificativa(tarefa: ITask) {
            if (!!tarefa.completed && !!tarefa.extraInfo && !!tarefa.extraInfo.Resultado) {
                return tarefa.extraInfo.Resultado;
            } else if (!tarefa.completed && !!tarefa.cancellation && !!tarefa.cancellation.reason) {
                return tarefa.cancellation.reason;
            }
            return '-';
        }
		
		public formatNomeUsuario(assignee) {
			if (assignee && this.usersNames && this.usersNames.has(assignee)) {
				return this.usersNames.get(assignee) + " (" + assignee + ")";
			}
			return assignee;
        }

        public formatResultadoFinal(tarefa: ITask) {
            if (!!tarefa.completed) {
                return 'Concluída';
            } else if (!tarefa.completed && !!tarefa.cancellation && !!tarefa.cancellation.reason) {
                return 'Cancelada';
            }
            return '-';
        }
    }
    angular
        .module("app.tarefas.minhas-tarefas")
        .service("app.tarefas.minhas-tarefas.ExportarTarefasService", ExportarTarefasService);
}